import { GameScreenMode } from "./GameScreenMode";
export function RegisterScreenModes() {
    GameScreenMode();
}
